import { type Palette } from '@mui/material'

import { VendorAIStatus } from '../vendor/vendor.types'

export const VENDORS_PER_PAGE = 10

export const vendorStatusMessage = (vendorStatus: VendorAIStatus): string => {
  switch (vendorStatus) {
    case VendorAIStatus.pending:
      return 'U obradi'
    case VendorAIStatus.approved:
      return 'Odobren'
    case VendorAIStatus.rejected:
      return 'Odbijen'
    default:
      return ''
  }
}

export const vendorStatusColors = (vendorStatus: VendorAIStatus, palette: Palette): string => {
  switch (vendorStatus) {
    case VendorAIStatus.pending:
      return palette.charts.orange400.main
    case VendorAIStatus.approved:
      return palette.charts.green200.main
    case VendorAIStatus.rejected:
      return palette.charts.red.main
    default:
      return 'inherit'
  }
}
